import { IColumns } from '../../../components/Table'

export type UserAuditLogsColumnKeys = 'id' | 'type' | 'description' | 'timestamp'

export const columns: IColumns<UserAuditLogsColumnKeys>[] = [
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'type',
    label: 'TYPE',
  },
  {
    id: 'description',
    label: 'DESCRIPTION',
  },
  {
    id: 'timestamp',
    label: 'DATE',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
]
